import { Link } from 'react-router-dom';
import ImageCheckFallback from '../../../shared/components/ImageCheckFallback';
import Pagination from '../../../shared/components/Pagination';
import { formatDate } from '../../../utils';

const SearchEvents = ({ list, pages }) => {
    return (
        <div id="view-news">
            <div className="top-table">
                <div className="count-results">이벤트</div>
                <Link to="/pagab010" className="more-results red">
                    이벤트 보기 &gt;
                </Link>
            </div>
            <ul className="table content-table">
                {list
                    .reduce((acc, item, index) => {
                        if (index % 2 === 0) {
                            acc.push(list.slice(index, index + 2));
                        }
                        return acc;
                    }, [])
                    .map((pair, index) => (
                        <li className="flex" key={`event-${index}`}>
                            {pair.map((item, subIndex) => (
                                <div className="result-item" key={`event-${index}-${subIndex}`}>
                                    <Link to={`/pagab020-${item?.seq}`} className="wrapImg">
                                        <ImageCheckFallback folderName={'event'} imgName={item?.webImg} alt="preview" />
                                    </Link>
                                    <div className="wrap-content">
                                        <Link className="item-title" to={`/pagab020-${item?.seq}`}>
                                            {item?.title}
                                        </Link>
                                        <div className="wrapMeta">
                                            <span className="status pink">진행중</span>
                                            <div className="wrap-date">
                                                <span className="start-date">{formatDate(item?.startDate)}</span>
                                                <span className="end-date">{formatDate(item?.endDate)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {pair.length !== 2 && <div></div>}
                        </li>
                    ))}
            </ul>
            <Pagination pages={pages} params="pageEvent" />
        </div>
    );
};
export default SearchEvents;
